import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';

const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
`;

const SliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 6px;
  background-color: #ddd;
  margin: 30px 0;
  border-radius: 3px;
`;

const Thumb = styled.div`
  position: absolute;
  top: -5px;
  width: 16px;
  height: 16px;
  background-color: #3498db;
  border-radius: 50%;
  cursor: pointer;
  transform: translateX(-50%);
  z-index: ${(props) => props.zIndex};
`;

const RangeValues = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const RangeSlider = ({ min, max, setFilters }) => {
  const [minValue, setMinValue] = useState(min);
  const [maxValue, setMaxValue] = useState(max);
  const range = max - min;

  // Effet pour mettre à jour `priceRange` lorsque les valeurs changent après relâchement de la souris
  useEffect(() => {
    const handleMouseUp = () => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        priceRange: `${minValue}-${maxValue}`,
      }));
    };
    // Ajout de l'événement pour `mouseup`
    document.addEventListener('mouseup', handleMouseUp);
    
    // Nettoyage de l'événement pour éviter les fuites de mémoire
    return () => document.removeEventListener('mouseup', handleMouseUp);
  }, [minValue, maxValue, setFilters]); // Dépendances pour déclencher à chaque changement de valeurs

  const handleMouseMove = useCallback(
    (event, type, sliderRect) => {
      if (event.clientX < sliderRect.left || event.clientX > sliderRect.right) return;

      const percent = (event.clientX - sliderRect.left) / sliderRect.width;
      const value = Math.round(min + percent * range);

      if (type === 'min' && value < maxValue) {
        setMinValue(value);
      } else if (type === 'max' && value > minValue) {
        setMaxValue(value);
      }
    },
    [min, maxValue, minValue, range]
  );

  const handleMouseDown = (event, type) => {
    const sliderRect = event.target.parentElement.getBoundingClientRect();
    const onMouseMove = (e) => handleMouseMove(e, type, sliderRect);

    document.addEventListener('mousemove', onMouseMove);

    document.addEventListener(
      'mouseup',
      () => {
        document.removeEventListener('mousemove', onMouseMove);
      },
      { once: true }
    );
  };

  return (
    <SliderContainer>
      <SliderWrapper>
        <Thumb
          style={{ left: `${((minValue - min) / range) * 100}%` }}
          onMouseDown={(e) => handleMouseDown(e, 'min')}
          zIndex={minValue === max ? 2 : 1}
        />
        <Thumb
          style={{ left: `${((maxValue - min) / range) * 100}%` }}
          onMouseDown={(e) => handleMouseDown(e, 'max')}
          zIndex={minValue === max ? 1 : 2}
        />
      </SliderWrapper>
      <RangeValues>
        <span>Min: {minValue} €</span>
        <span>Max: {maxValue} €</span>
      </RangeValues>
    </SliderContainer>
  );
};

export default RangeSlider;
